module.exports = __webpack_public_path__ + "img/crossword.9a3fa3db.svg";